//Removes specified symbol from the beginning and from the end of the string

export const trimSymbol = (trimmedString: string, symbol = " "): string => {
  const regExp = new RegExp(`^${symbol}+|${symbol}+$`, "g");
  return trimmedString.replace(regExp, "");
};
